// Centralized course image mapping
// This file maps course titles to their specific images
// Based on exact course names from courseCategories in data.js

export const courseImages = {
  // MEP Category (exact names from data.js)
  'MEP Comprehensive Course': require('../assets/MEP.jpg'),
  'MEP Modeler Course': require('../assets/MEP modeler course.jpg'),
  'MEP BIM Coordinator Course': require('../assets/MEP BIM Coordinator.jpg'),

  // Popular Courses (exact names from data.js)
  'BIM Coordinator Course': require('../assets/BIM Coordinator course.jpg'),
  'Revit Architecture': require('../assets/Advance Bim.jpeg'),
  'Navisworks Manage & Simulation': require('../assets/Navisworks Manage & Simulation1.jpg'),
  'BIM Manager Course': require('../assets/BIM Manager course.jpg'),

  // Mechanical (HVAC) (exact names from data.js)
  'HVAC Modeler': require('../assets/HVAC Modeler1.jpg'),

  // Electrical (exact names from data.js)
  'Electrical Modeler': require('../assets/Electrical Modeler1.jpg'),
  'ELV Modeler': require('../assets/ELV Modeler.jpg'),

  // Plumbing (exact names from data.js)
  'Plumbing Modeler': require('../assets/Plumbing Modeler1.jpg'),

  // Fire Fighting (exact names from data.js)
  'Fire Fighting Modeler': require('../assets/Fire Fighting modeler.jpg'), // Using fallback as original file has no extension

  // Advanced BIM (exact names from data.js)
  'Special Tools for BIM': require('../assets/Special tools form BIM.jpg'),

  // BIM Automation (exact names from data.js)
  'Dynamo for BIM': require('../assets/Dynamo for BIM1.jpg'),
  'Add-in Creation': require('../assets/Add-in Creation.jpg'),

  // Architecture (exact names from data.js)
  'Architecture': require('../assets/Architecture.jpg'),
  '3ds Max': require('../assets/3D MAX.jpg'),
  'SketchUp': require('../assets/Sketch up.jpg'),
  'V-Ray': require('../assets/Vray.jpg'),
  'Lumion': require('../assets/Lumion1.jpg'),
  'Enscape': require('../assets/Enscape1.jpg'),

  // Structural (exact names from data.js)
  'Structural': require('../assets/Structural1.jpg'),

  // Legacy products array courses (for HomePopularCourses.jsx)
  'Revit MEP (Mechanical, Electrical & Plumbing)': require('../assets/MEP.jpg'),
  'Revit Structural': require('../assets/STRUCTURAL.jpg'),

  'HVAC Basic System Design': require('../assets/HVAC Basic System Design1.jpg'),
};

// Fallback image for courses without specific images
export const fallbackImage = require('../assets/Advance Bim.jpeg');

// Function to get appropriate image for a course
export const getCourseImage = (courseTitle) => {
  return courseImages[courseTitle] || fallbackImage;
};

const courseImageConfig = { courseImages, getCourseImage, fallbackImage };
export default courseImageConfig;
